import { TypographyCaption } from '@heidi/design-system/typography';
import { cn } from '@/lib/cn';
import { useTranslations, type TranslationKey } from '@heidi/runtime/i18n';
import type { FC } from 'react';
import { EvidenceCircleLoader } from '@/components/ui/evidence-circle-loader';

interface StreamRecoveryIndicatorProps {
  className?: string;
}

export const StreamRecoveryIndicator: FC<StreamRecoveryIndicatorProps> = ({
  className,
}) => {
  const { t } = useTranslations();

  return (
    <div
      className={cn(
        'flex min-w-0 items-center gap-3 text-text-secondary',
        className
      )}
    >
      <EvidenceCircleLoader
        size={28}
        gooey
        spread={1.4}
        formation="square"
        easing="soft"
        duration={4}
      />
      <TypographyCaption className="animate-pulse text-text-tertiary">
        {t('chat.reconnecting' as TranslationKey)}
      </TypographyCaption>
    </div>
  );
};
